function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function isObject(data) {
  return Object.prototype.toString.call(data) === '[object Object]';
}

var RuntimeEnvManager = /*#__PURE__*/function () {
  function RuntimeEnvManager(options) {
    if (options === void 0) {
      options = {};
    }

    // 构建时的环境变量
    var compileEnvs = process.env; // 运行时挂载在window上的环境变量

    var runtimeEnvs = {}; // dev时候注入的环境变量

    var devInjectEnvs = {};

    if (typeof window !== 'undefined') {
      runtimeEnvs = window[options.key || 'envConfig'] || {};
    }

    if (compileEnvs.NODE_ENV === 'development' && isObject(options.devInjectEnvs)) {
      devInjectEnvs = _extends({}, options.devInjectEnvs);
    }

    this.env = Object.freeze(_extends({}, compileEnvs, runtimeEnvs, devInjectEnvs));
  }
  /**
  * @param {string} key 环境变量名称
  */


  var _proto = RuntimeEnvManager.prototype;

  _proto.get = function get(key) {
    var isValid = Object.hasOwnProperty.call(this.env, key);

    if (!isValid) {
      throw new Error("\u5F53\u524D\u7684\u73AF\u5883\u53D8\u91CF\u96C6\u5408\u4E2D\u4E0D\u5B58\u5728[" + key + "]\uFF0C\u8BF7\u68C0\u67E5\u53D8\u91CF\u540D\u79F0\u662F\u5426\u6B63\u786E");
    }

    return this.env[key];
  };

  return RuntimeEnvManager;
}();

export { RuntimeEnvManager };
//# sourceMappingURL=iconfig-env-runtime.esm.js.map
